class BrowserPolicyController {
	constructor(browser, $window, $ngRedux, NotificationActions) {
		'ngInject';

		this.$window = $window;
		this.store = $ngRedux;
		this.notificationActions = NotificationActions;
		this.currentBrowser = browser;
	}

	$onInit() {
		const actions = Object.assign({}, this.notificationActions);
		this.unsubscribe = this.store.connect(this.mapStateToThis, actions)(this);
	}


	$onDestroy() {
		this.unsubscribe();
	}

	mapStateToThis(state) {
		let { visible } = state.notification;
		return { visible };
	}

	dismiss() {
		this.$window.history.back();
	}

}

export default {
	template: require('./browser-policy.template.html'),
	controller: BrowserPolicyController,
	bindings: {},
	controllerAs: 'vm'
};
